import Vue from "vue";
import Vuex from "vuex";

import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from 'axios';
import "./registerServiceWorker";
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';


//import tinycolor from 'tinycolor2';

import { Caret } from 'textarea-caret-ts';

//timto zjististime jestli je něco viditelné
//https://vuejsexamples.com/detect-when-an-element-is-becoming-visible-or-hidden-on-the-page/
import VueObserveVisibility from 'vue-observe-visibility';

import VueI18n from 'vue-i18n';
import BaseTLComponent from './BaseTLComponent';
import BaseTLDetailComponent from './BaseTLDetailComponent';
import BaseTLTableComponent from './BaseTLTableComponent';
import BaseTLTableBase from './BaseTLTableBase';
import { router as tlRouter } from "./router";


//VaPTODO - toto zde nedavat, at to nadefinuje ten kdo ho
import tlStore from './StoreBase';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';


import { ImagePlugin } from 'bootstrap-vue'

import * as RightHelper from "../Helpers/RightHelper";

import * as TranslateHelper from "../Helpers/TranslateHelper";

import * as ObjectTypesHelper from "../Helpers/ObjectTypesHelper";

import Multiselect from 'vue-multiselect';


//https://github.com/lupas/vue-keypress
import Keypress from 'vue-keypress';
 
//print  FUNGUJE jen to vraci chybu do vypisu
//@ts-ignore
import VueHtmlToPaper from "vue-html-to-paper";

//nepouzit bootstrap.min.css - pak se objevi vsechny volby tisku
//jinak nevim na co jsou ty options když to stejne nebere

//import  Vue2TinymceEditor  from "vue2-tinymce-editor";

import { BEmbed } from 'bootstrap-vue';
Vue.component('b-embed', BEmbed)

//funguje obnovit
const options = {
	name: 'test',
	specs: [

		'fullscreen=yes',
		'titlebar=no',
		'scrollbars=yes'
	],
	//styles: [
	//	//'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
	//	'https://unpkg.com/kidlat-css/css/kidlat.css',
	//	'../Pages/App/src/css/own_style.css'
	//]
}


Vue.use(VueHtmlToPaper, options);


//print end




//tohle může modifikovat předchozi dva importy
//import '../src/bootstrap/scss/_variables.scss';


//import JwPagination from 'jw-vue-pagination';

//import BootstrapVueTreeview from "bootstrap-vue-treeview";
//import VueSimpleContextMenu from "vue-simple-context-menu"; //tests
//import VueContext from "vue-context";
//import VCCM from "vue-custom-context-menu";



//VaPTODO - SHP zde nemuze byt
//import BaseTLWorkingUnitTraining from "../Pages/Shp/WorkingUnit/WorkingUnitsTrainingList.vue";
//import PlanSheet from "../Pages/Shp/PlanSheet/PlanSheet.vue";
//import PlanSheetV2 from "../Pages/Shp/PlanSheet/PlanSheetV2.vue";
//import PlanSheetV4 from "../Pages/Shp/PlanSheet/PlanSheetV4.vue";
//import Absence from "../Pages/Shp/Absence/AbsenceDetail.vue";
//import OperationalRecord from "../Pages/Shp/OperationalRecord/OperationalRecordDetail.vue";

import ButtonPlugin from 'bootstrap-vue';
import BButton from 'bootstrap-vue';

import { AxiosResponse } from 'axios';
//import { VueClass } from "vue-class-component/lib/declarations";

//autorizace

import GAuth from 'vue-google-oauth2';
//const vue-xxxxxx = require('vue-xxxxxx');
//// import { vue-xxxxxx } from 'vue-xxxxxx'

//const facebookLogin = require("facebook-login-vuejs");

//const FacebookStrategy = require("passport-facebook").Strategy;

//import VFacebookLogin from 'vue-facebook-login-component';

//import facebookLogin from 'facebook-login-vuejs';
//@ts-ignore
//import { initFbsdk } from '@/config/facebook_oAuth.js'


//import Clarity from 'clarity-js';
////@ts-ignore
//Clarity.configure({
//	projectId: 'gqum4x0995',
//});


//google autentizace    ODKOMENTOVAT TEN SPRÁVNÝ
//produkcni
var googleAuth = "446787486318-16o2lgdqd08h72bl14etri4esmm4m2a3.apps.googleusercontent.com";
//testovaci
//var googleAuth = "309238973775-jijufotl4ii8f7ls23torln0eg0sepcl.apps.googleusercontent.com";
//dev
//var googleAuth = "419814844945-43s2t1d234s320fsb7k6jhckrs193p0l.apps.googleusercontent.com";


import BaseTLProgress from "../../Components/ComponentsBase/BaseTLProgress.vue";
import BaseTLTextArea from "../../Components/ComponentsBase/BaseTLTextArea.vue";
import BaseTLTest from "../../Components/ComponentsBase/BaseTLTest.vue";
import BaseTLInput from "../../Components/ComponentsBase/BaseTLInput.vue";
import BaseTLFileInput from "../../Components/ComponentsBase/BaseTLFileInput.vue";
import BaseTLButton from "../../Components/ComponentsBase/BaseTLButton.vue";
import BaseTLLabel from "../../Components/ComponentsBase/BaseTLLabel.vue";
import BaseTLList from "../../Components/ComponentsBase/BaseTLList.vue";
import BaseTLImage from "../../Components/ComponentsBase/BaseTLImage.vue";
import BaseTLInfoPanel from "../../Components/ComponentsBase/BaseTLInfoPanel.vue";
import BaseTLCheckBox from "../../Components/ComponentsBase/BaseTLCheckBox.vue";
import BaseTLCheckBoxDesign from "../../Components/ComponentsBase/BaseTLCheckBoxDesign.vue";
import BaseTLTreeViewItem from "../../Components/ComponentsBase/BaseTLTreeViewItem.vue";
import BaseTLTreeView from "../../Components/ComponentsBase/BaseTLTreeView.vue";
import BaseTLContextMenu from "../../Components/ComponentsBase/BaseTLContextMenu.vue";
import BaseTLModalDialog from "../../Components/ComponentsBase/BaseTLModalDialog.vue";
import BaseTLModalDialogSimple from "../../Components/ComponentsBase/BaseTLModalDialogSimple.vue";
import BaseTLModalDialogTag from "../../Components/ComponentsBase/BaseTLModalDialogTag.vue";
import BaseTLModalDialogEditable from "../../Components/ComponentsBase/BaseTLModalDialogEditable.vue";
import BaseTLModalDialogTable from "../../Components/ComponentsBase/BaseTLModalDialogTable.vue";
import BaseTLModalDialogDetail from "../../Components/ComponentsBase/BaseTLModalDialogDetail.vue";
import BaseTLModalDialogPopUp from "../../Components/ComponentsBase/BaseTLModalDialogPopUp.vue";
import BaseTLDropDownList from "../../Components/ComponentsBase/BaseTLDropDownList.vue";

import BaseTLTableRest from "../../Components/ComponentsBase/BaseTLTableRest.vue";
import BaseTLTable from "../../Components/ComponentsBase/BaseTLTable.vue";
import BaseTLTableEditable from "../../Components/ComponentsBase/BaseTLTableEditable.vue";
import BaseTLFilter from "../../Components/ComponentsBase/BaseTLFilter.vue";
import BaseTLSpinner from "../../Components/ComponentsBase/BaseTLSpinner.vue";

import BaseTLModalDialogTreeView from "../../Components/ComponentsBase/BaseTLModalDialogTreeView.vue";

import BaseTLTreeViewCheckItem from "../../Components/ComponentsBase/BaseTLTreeViewCheckItem.vue";
import BaseTLTreeCheckView from "../../Components/ComponentsBase/BaseTLTreeCheckView.vue";

import BaseTLSchedule from "../../Components/ComponentsBase/BaseTLSchedule.vue";
import BaseTLGrid from "../../Components/ComponentsBase/BaseTLGrid.vue";
import BaseTLGridItem from "../../Components/ComponentsBase/BaseTLGridItem.vue";
import BaseTLFilterValueItem from "../../Components/ComponentsBase/BaseTLFilterValueItem.vue";

//vice pouzitelne prvky - VaPTODO - toto pak predelat, nejsou to vice pouzitelne prvky, pouzivaji se pouze na jedinem miste, jen je to base componenta
import BaseTLSubstitute from "../../Pages/CorBase/Employment/SubstituteList.vue";
import BaseTLEmployment from "../../Pages/CorBase/Employment/EmploymentList.vue";
import BaseTLPersons from "../../Pages/CorBase/Person/PersonList.vue";
import BaseTLUsers from "../../Pages/CorBase/User/UserList.vue";
import BaseTagDetail from "../../Pages/CorBase/Tag/TagDetail.vue";

//end test
export * from "../Helpers/ModuleHelper";
export * from "../Helpers/DateTimeHelper";
export * from "../Helpers/CheckBoxHelper";
export * from "../Helpers/TranslateHelper";
export * from "../Helpers/JwtTokenHelper";
export * from "../Helpers/ConsoleLoggerHelper";
export * from "../Helpers/LoginLogoutHelper";

export {
	GAuth,
//	facebookLogin,
	Vue, Vuex, BaseTLDetailComponent, BaseTLTable, BaseTLTableRest, BaseTLComponent, BaseTLTableComponent, Component, Watch, Prop, tlRouter, tlStore,
	AxiosResponse, RightHelper, TranslateHelper, Multiselect, ObjectTypesHelper, Keypress, Caret, BaseTLTableBase
};

// export all services
//VaPTODO - Krome COR to zde nemuze byt
export * from "../../Services/CorBase/AllCorServices";
//export * from "../../Services/StuBase/AllStuServices";
//export * from "./Services/Acc/AllAccServices";
//export * from "./Services/Cont/AllConServices";
//export * from "./Services/Shp/AllShpServices"

Vue.config.productionTip = process.env.NODE_ENV === "production";
Vue.config.performance = process.env.NODE_ENV !== "production";
// VaP todo - toto je hnus, lepsi to udelat jinak, bud pouzit prislusny env file (production develop) nebo vymyslet neco jineho, ale pro zacatek to staci
// VaP - Kurth nasel nejspis univerzalni nastaveni, ktere funguje vsude
Axios.defaults.baseURL = "/api";
//Axios.defaults.baseURL = "http://127.0.0.1:6010/api";
//Axios.defaults.baseURL = "https://isdisp-test.jlv.cz/api";

//@ts-ignore
//Clarity.start();

Vue.use(VueObserveVisibility);



Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueI18n);
Vue.use(ButtonPlugin);
Vue.use(BButton);
Vue.use(ImagePlugin);


//Vue.use(new FacebookStrategy({
//	clientID: '524521565998002',
//	clientSecret: '8f03514a7bc5287918aa8467491d1bce',
//	callbackURL: "http://localhost:3000/auth/facebook/secrets"
//}
	//,
	//function (accessToken, refreshToken, profile, cb) {
	//	User.findOrCreate({ facebookId: profile.id }, function (err, user) {
	//		return cb(err, user);
	//	});
	//}
//));

//FacebookStrategy.use(new FacebookStrategy({
//	clientID: '524521565998002',
//	clientSecret: '8f03514a7bc5287918aa8467491d1bce',
//	callbackURL: "http://localhost:3000/auth/facebook/secrets"
//},
//	function (accessToken, refreshToken, profile, cb) {
//		User.findOrCreate({ facebookId: profile.id }, function (err, user) {
//			return cb(err, user);
//		});
//	}
//));


//autirizace pres google - funguje
//const gauthOption = {
//	clientId: '159802473235-jd6kdln7nekf8s5o6dg0t1vqn130idio.apps.googleusercontent.com',
//	scope: 'profile email',
//	prompt: 'select_account'
//}


const gauthOption = {
	clientId: googleAuth,
	scope: 'profile email',
	prompt: 'select_account'
}

Vue.use(GAuth, gauthOption);
Vue.component('multiselect', Multiselect);
//Vue.component('jw-pagination', JwPagination);
Vue.component("base-tl-progress", BaseTLProgress);
Vue.component("base-tl-textarea", BaseTLTextArea);
Vue.component("base-tl-test", BaseTLTest);
Vue.component("base-tl-spinner", BaseTLSpinner);
Vue.component("base-tl-filter", BaseTLFilter);
Vue.component("base-tl-input", BaseTLInput);
Vue.component("base-tl-file-input", BaseTLFileInput);
Vue.component("base-tl-button", BaseTLButton);
Vue.component("base-tl-label", BaseTLLabel);
Vue.component("base-tl-list", BaseTLList);
Vue.component("base-tl-image", BaseTLImage);
Vue.component("base-tl-infopanel", BaseTLInfoPanel);
Vue.component("base-tl-checkbox", BaseTLCheckBox);
Vue.component("base-tl-checkbox-design", BaseTLCheckBoxDesign);
Vue.component("base-tl-tree-view-item", BaseTLTreeViewItem);
Vue.component("base-tl-treeview", BaseTLTreeView);
Vue.component("base-tl-tree-view-check-item", BaseTLTreeViewCheckItem);
Vue.component("base-tl-treecheckview", BaseTLTreeCheckView);
Vue.component("base-tl-schedule", BaseTLSchedule);
Vue.component("base-tl-grid", BaseTLGrid);
Vue.component("base-tl-grid-item", BaseTLGridItem);
Vue.component("base-tl-filter-value-item", BaseTLFilterValueItem);
Vue.component("base-tl-contextmenu", BaseTLContextMenu);
Vue.component("base-tl-modal-dialog", BaseTLModalDialog);
Vue.component("base-tl-modal-dialog-simple", BaseTLModalDialogSimple);
Vue.component("base-tl-modal-dialog-tag", BaseTLModalDialogTag);
Vue.component("base-tl-modal-dialog-editable", BaseTLModalDialogEditable);
Vue.component("base-tl-modal-dialog-table", BaseTLModalDialogTable);
Vue.component("base-tl-modal-dialog-treeview", BaseTLModalDialogTreeView);
Vue.component("base-tl-modal-dialog-detail", BaseTLModalDialogDetail);
Vue.component("base-tl-modal-dialog-popup", BaseTLModalDialogPopUp);
Vue.component("base-tl-drop-down-list", BaseTLDropDownList);
Vue.component("base-tl-table-rest", BaseTLTableRest);
Vue.component("base-tl-table", BaseTLTable);
Vue.component("base-tl-table-editable", BaseTLTableEditable);

//vice pouzitelne prvky - VaPTODO - toto pak predelat, nejsou to vice pouzitelne prvky, pouzivaji se pouze na jedinem miste, jen je to base componenta
Vue.component("base-tl-substitute", BaseTLSubstitute);
Vue.component("base-tl-employments", BaseTLEmployment);
Vue.component("base-tl-persons", BaseTLPersons);
Vue.component("base-tl-users", BaseTLUsers);
Vue.component("base-tl-tag-detail", BaseTagDetail);

//globalni pro test
Vue.prototype.$blogName = 'LogRocket'

